import styled from 'styled-components';
import { IThemeProvider, ITheme } from '../../styles/theme';
import LogoIcon from '@/assets/icons/communiq-logo-grey.svg?react';
import LogOutIcon from '@/assets/icons/logoutIcon.svg?react';

export const MenuCont = styled.div`
  position: relative;
  min-width: 168px;
  height: 100%;
`;

export const SideMenuCont = styled.div`
  display: flex;
  position: fixed;
  max-width: 168px;
  min-width: 168px;
  height: 100%;
  top: 0;
  flex-direction: column;
  align-self: stretch;
  z-index: 100;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.primary[100]};
    border-radius: 0px 0px ${theme.layout.spacing.giga} 0px;
  `}
`;

interface IMenuElement {
  theme: ITheme;
  active?: boolean;
  noHover?: boolean;
}

export const MenuElement = styled.div<IMenuElement>`
  display: flex;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  cursor: pointer;
  justify-content: center;
  position: relative;
  bottom: 0;
  border: 2px solid transparent;

  ${({ theme, active, noHover }: IMenuElement) => `
    font-weight: ${active ? '700' : '400'};
    padding: ${theme.layout.spacing.mili} ${theme.layout.spacing.mikro}; 
    color: ${active ? theme.colors.primary[100] : theme.colors.neutral.primary[5]};
    border-radius: ${theme.layout.spacing.nano};
    margin: 8px ${theme.layout.spacing.centy} 0;
    background: ${active ? theme.colors.neutral.primary[5] : 'transparent'};
    ${
      !noHover &&
      `
        &:hover {
          border: ${active ? 'none' : `2px solid ${theme.colors.neutral.primary[5]}`};
        }
    `
    }
  `}
`;

export const MenuBottomElement = styled(MenuElement)`
  align-items: center;
  margin: auto;
  margin-bottom: 96px;
  font-weight: 700;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const LogoutIcon = styled(LogOutIcon)`
  margin-right: 10px;
`;

export const Logo = styled(LogoIcon)`
  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.mega};
  `}
`;

export const ChangeLangCont = styled.div`
  ${({ theme }) => `
    position: relative;
    margin: 0 0 ${theme.layout.spacing.decy};
  `};
`;

export const LogoutCont = styled.div`
  position: relative;
  text-transform: none;
`;
